module.exports = __webpack_public_path__ + "img/letItGo.74d38d5c.png";